<template>
  <div>
    <!-- Trigger Button -->
    <v-btn 
      :disabled="disabled" 
      color="primary" 
      :loading="loading" 
      @click="fetch" 
      text
      class="font-weight-black text-uppercase tracking-widest rounded-lg px-4 transition-fast-in-fast-out h-44"
    >
      <v-icon left size="16">fas fa-file-export</v-icon>
      Exportar
    </v-btn>

    <!-- Download Dialog -->
    <v-dialog v-model="dataReady" max-width="400" transition="scale-transition">
      <v-card class="modern-card overflow-hidden rounded-xl">
        <!-- Premium Header -->
        <div class="bg-grey-light pa-6 border-bottom">
          <div class="d-flex align-center">
            <v-avatar color="primary" size="40" class="mr-4 shadow-sm border-white-sm">
              <v-icon color="white" small>fas fa-download</v-icon>
            </v-avatar>
            <div>
              <div class="text-h6 font-weight-black primary--text lh-1">Exportar Productos</div>
              <div class="caption grey--text font-weight-bold text-uppercase tracking-wider mt-1">Items en pre-producción</div>
            </div>
          </div>
        </div>

        <v-card-text class="text-center pa-8">
          <v-avatar color="primary lighten-5" size="80" class="mb-6">
            <v-icon color="primary" size="40">fas fa-boxes</v-icon>
          </v-avatar>
          <div class="body-1 primary--text font-weight-bold mb-2">¡Exportación Preparada!</div>
          <div class="caption grey--text px-4 mb-6">El listado de productos en etapa técnica ha sido procesado para su descarga.</div>

          <vue-json-to-csv
            :json-data="products"
            :labels="labels"
            :csv-title="csvTitle"
            :separator="';'"
            @success="val => handleSuccess(val)"
            @error="val => handleError(val)">
            <v-btn 
              color="success" 
              block 
              large 
              elevation="0"
              height="48"
              class="font-weight-black text-none rounded-lg shadow-sm"
            >
              <v-icon left>fas fa-download</v-icon>
              Descargar CSV
            </v-btn>
          </vue-json-to-csv>
        </v-card-text>

        <v-divider class="mx-8 opacity-10"></v-divider>
        <div class="pa-4 text-center">
          <v-btn text small color="grey" class="text-none font-weight-bold" @click="dataReady = false">Cerrar</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import notifications from '@/utils/notifications'
import {fetchProductionProducts} from '@/api/production'
import VueJsonToCsv from 'vue-json-to-csv'
import moment from 'moment'
export default {
  name:"ExportPrestageProducts",
  props:['filter','options','disabled'],
  components: {VueJsonToCsv,},
  data() {
    return {
      loading: false,
      products:[],
      dataReady:false,
      labels:{ 
        work_order__id:{title:'OT'},
        library_product__sku:{title:'Codigo'},
        name:{title:'Producto'},
        work_order__sales_note__customer__name:{title:'Cliente'},
        work_order__created_at:{title:'Creada'},
        work_order__delivery_date: { title: 'Entrega' },
        stage:{title:'Etapa'}
       },
       csvTitle:`export_productos_preproduccion_${moment(new Date().toISOString()).format('DD-MM-yyyy_HH:mm')}`
    }
  },
  methods:{
    async fetch(){
      this.loading=true
      //Arreglando variables de fecha en caso de ser null
      if(!this.filter.created_after) this.filter.created_after=''
      if(!this.filter.created_before) this.filter.created_before=''
      if(!this.filter.delivery_after) this.filter.delivery_after=''
      if(!this.filter.delivery_before) this.filter.delivery_before=''
      if(!this.filter.seller) this.filter.seller=''
      if(this.filter.stage==-2) this.filter.stage=''

      if (this.filter.stage===-1){
        notifications.showError('No se puede exportar productos en etapa de produccion')
        this.loading=false
        return false
      }
      const {sortBy, sortDesc}=this.options

      const query=`ordering=${sortDesc[0]?'-'+sortBy[0]:sortBy[0]}&stage=${this.filter.stage}&created_after=${this.filter.created_after}&created_before=${this.filter.created_before}&delivery_after=${this.filter.delivery_after}&delivery_before=${this.filter.delivery_before}&seller=${this.filter.seller}&in_prestage=true&prestage__id=${this.filter.stage}`

      await fetchProductionProducts(query)
      .then((data)=>{
        this.products = data.results
        if (this.products.length===0){
          notifications.showInfo('No se encontraron productos para exportar')
          this.loading=false
          return false
        }
        this.products.forEach(w=>{
          w.work_order__created_at=moment(w.work_order__created_at).format("DD/MM/yyyy HH:mm")
          w.work_order__delivery_date=moment(w.work_order__delivery_date).format("DD/MM/yyyy HH:mm")
          w.stage=w.prestage.name
        })
        this.dataReady=true
      })
      .catch((err)=>notifications.showError('Error Cargando Ordenes de Trabajo' + err))
      //Calculo porcentaje de completado del producto
      this.loading=false
    },
    handleSuccess(val){
      console.log(val)
      notifications.showSuccess('Productos Exportados')
      this.dataReady=false
    },
    handleError(val){
      console.log(val)
      notifications.showError('Error Exportando Productos')
      this.dataReady=false
    }
  }

}
</script>